import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import {
  Btn,
  Cnpj,
  CustomCalendar,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomDropdown,
  CustomModal,
  CustomPanel,
  CustomTabView,
  DateTime,
  InputCnpj,
  InputNumeroInteiro,
  InputPhone,
  InputText,
  Loading,
  PageHeader,
} from '../../../../components'

import { showMessageBox } from '../../../../store/actions/system.actions'
import * as EmissoresHttp from '../../../../services/api/https/settings/emissor-cte.http'
import * as SystemHttp from '../../../../services/api/https/system/system.http'

import { errorHandler } from '../../../../services/util/error.service'
import { TabPanel } from 'primereact/tabview'
import { Fieldset } from 'primereact/fieldset'
import { tableCellCentered } from '../../../../assets/js/styles'

import ModalUltimoEmitido from './ModalUltimoEmitido'
import CertificadoCiotTab from './CertificadoCiotTab'
import {
  AMBIENTES_NFSE,
  OPCAO_SIMPLES_ME_EPP,
  OPCOES_SIMPLES_NACIONAL,
  REGIMES_APURACAO_SIMPLES,
  REGIMES_ESPECIAIS_TRIBUTACAO,
} from '../../../../constants/fiscal'

function EmissorCte({ dispatch, history }) {
  // Vars
  const initEmissor = {
    id: null,
    rntrc: '',
    cnpj: '',
    razao_social: '',
    inscricao_estadual: '',
    uf: '',
    indicador_icms: '',
    telefone: '(__)_____-____',
    activated: true,
    token_homolog: '',
    token_prod: '',
    cte_num_serie: null,
    cte_ultimo_emitido: null,
    address: '',
    number: '',
    district: '',
    city_id: null,
    cep: '',
    selectedCity: null,
    ambiente_nfse: null,
    inscricao_municipal: '',
    opcao_simples_nacional: null,
    regime_apuracao_simples: null,
    regime_especial_tributacao: null,
    email: '',
  }

  // Hooks
  const [isLoading, setIsLoading] = useState(false)
  const [emissores, setEmissores] = useState([])
  const [state, setState] = useState(initEmissor)
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    getEmissores()
  }, [])

  // Events
  const onBtnNovo = () => {
    setState(initEmissor)
    setShowModal(true)
  }

  const onModalClose = () => {
    setShowModal(false)
  }

  const onModalSave = async emissor => {
    const index = emissores.findIndex(l => l.id === emissor.id)
    if (index !== -1) {
      const nEmissores = [...emissores]
      nEmissores[index] = emissor
      setEmissores(nEmissores)
    } else {
      setEmissores([...emissores, emissor])
    }
    setShowModal(false)
  }

  const onModalError = error => {
    dispatch(showMessageBox(null, error))
  }

  const onEmissorUpdated = emissor => {
    setEmissores(prev => prev.map(e => (e.id === emissor.id ? emissor : e)))
  }

  const onRowClicked = emissor => {
    setState({
      id: emissor.id,
      rntrc: emissor.rntrc || '',
      cnpj: emissor.cnpj,
      razao_social: emissor.razao_social,
      inscricao_estadual: emissor.inscricao_estadual || '',
      uf: emissor.uf,
      indicador_icms: emissor.indicador_icms,
      telefone: emissor.telefone,
      activated: emissor.activated,
      token_homolog: emissor.token_homolog || '',
      token_prod: emissor.token_prod || '',
      validade_certificado: new Date(emissor.validade_certificado.split('T')[0] + 'T04:00:00'),
      cte_num_serie: emissor.cte_num_serie,
      cte_ultimo_emitido: emissor.cte_ultimo_emitido,
      address: emissor.address || '',
      number: emissor.number || '',
      district: emissor.district || '',
      city_id: emissor.city_id || null,
      cep: emissor.cep || '',
      selectedCity: emissor.city_id ? { id: emissor.city_id, name: emissor.city_name } : null,
      ambiente_nfse: emissor.ambiente_nfse || null,
      inscricao_municipal: emissor.inscricao_municipal || '',
      opcao_simples_nacional: emissor.opcao_simples_nacional,
      regime_apuracao_simples: emissor.regime_apuracao_simples,
      regime_especial_tributacao: emissor.regime_especial_tributacao,
      email: emissor.email || '',
    })
    setShowModal(true)
  }

  // Helpers
  const getEmissores = async () => {
    try {
      setIsLoading(true)
      const fetchedEmissores = await EmissoresHttp.getEmissores()

      setEmissores(fetchedEmissores)
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div>
      <PageHeader>S.23 - Gestão de Emissores de CTe</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={onBtnNovo} onVoltar={history.goBack}>
          {isLoading ? (
            <div className="text-center">
              <Loading size="md" />
            </div>
          ) : (
            <EmissorDataTable emissores={emissores} onRowClick={onRowClicked} />
          )}
        </CustomPanel>
      </div>
      <EmissorModal
        isVisible={showModal}
        onError={onModalError}
        onSuccess={onModalSave}
        onEmissorUpdated={onEmissorUpdated}
        onCertificadoSalvo={() => {
          dispatch(showMessageBox('Certificado enviado com sucesso!', null))
          getEmissores()
        }}
        onClose={onModalClose}
        emissor={state}
      />
    </div>
  )
}

const IndicadorIcmsOptions = [
  {
    id: 1,
    name: 'Contribuinte ICMS',
  },
  {
    id: 2,
    name: 'Contribuinte isento de inscrição',
  },
  {
    id: 9,
    name: 'Não Contribuinte',
  },
]

function EmissorModal({
  emissor,
  isVisible,
  onClose,
  onSuccess,
  onEmissorUpdated,
  onCertificadoSalvo,
  onError,
}) {
  const [activeIndex, setActiveIndex] = useState(0)
  const [validadeCertificado, setValidadeCertificado] = useState(null)

  // Render
  return (
    <CustomModal
      width={800}
      header="Emissor"
      isVisible={isVisible}
      contentStyle={{ overflowY: 'auto', maxHeight: '80vh' }}
      onClose={() => {
        setActiveIndex(0)
        setValidadeCertificado(null)
        onClose()
      }}
    >
      <CustomTabView activeIndex={activeIndex} onTabChange={value => setActiveIndex(value)}>
        <TabPanel header="Dados">
          <DadosTab
            emissor={emissor}
            validadeCertificado={validadeCertificado}
            onSuccess={onSuccess}
            onEmissorUpdated={onEmissorUpdated}
            onError={onError}
          />
        </TabPanel>
        <TabPanel header="Certificado do CIOT">
          <CertificadoCiotTab
            emissor={emissor}
            onError={onError}
            onSalvo={info => {
              // A API grava a validade do certificado no emissor; a aba Dados não pode voltar a data antiga
              setValidadeCertificado(new Date(`${String(info.valido_ate).slice(0, 10)}T04:00:00`))
              onCertificadoSalvo()
            }}
          />
        </TabPanel>
      </CustomTabView>
    </CustomModal>
  )
}

function DadosTab({ emissor, validadeCertificado, onSuccess, onEmissorUpdated, onError }) {
  // Hooks
  const [state, setState] = useState({
    ufs: [],
    cities: [],
    selectedUf: null,
    selectedCity: null,
    selectedIndicadorICMS: null,
    ...emissor,
  })
  const [showUltEmitidoModal, setShowUltEmitidoModal] = useState(false)

  useEffect(() => {
    const loadUf = async () => {
      await fetchUFs(emissor.uf)
      // Carregar cidades se já tem UF e city_id
      if (emissor.uf && emissor.city_id) {
        const ufs = await SystemHttp.getUfs()
        const ufEncontrada = ufs.find(uf => uf.uf === emissor.uf)
        if (ufEncontrada && ufEncontrada.id) {
          const cities = await SystemHttp.getCities(ufEncontrada.id)
          const cidadeEncontrada = cities.find(city => city.id === emissor.city_id)
          setState(prevState => ({
            ...prevState,
            cities: cities,
            selectedCity: cidadeEncontrada || null,
          }))
        }
      }
    }
    setState({
      ufs: [],
      cities: [],
      selectedUf: null,
      selectedCity: null,
      selectedIndicadorICMS: IndicadorIcmsOptions.find(
        indicador => indicador.id === emissor.indicador_icms,
      ),
      token_homolog: emissor.token_homolog || '',
      token_prod: emissor.token_prod || '',
      ...emissor,
    })
    loadUf()
  }, [emissor])

  // Carregar cidades quando selectedUf mudar
  useEffect(() => {
    if (state.selectedUf) {
      fetchCities(state.selectedUf.id)
    }
  }, [state.selectedUf])

  useEffect(() => {
    if (validadeCertificado)
      setState(prevState => ({ ...prevState, validade_certificado: validadeCertificado }))
  }, [validadeCertificado])

  // Events
  const onBtnSalvarClicked = async () => {
    try {
      const {
        id,
        rntrc,
        cnpj,
        razao_social,
        inscricao_estadual,
        uf,
        indicador_icms,
        telefone,
        activated,
        validade_certificado,
        token_homolog,
        token_prod,
        cte_num_serie,
        cte_ultimo_emitido,
        address,
        number,
        district,
        city_id,
        cep,
        ambiente_nfse,
        inscricao_municipal,
        opcao_simples_nacional,
        regime_apuracao_simples,
        regime_especial_tributacao,
        email,
      } = state

      // RNTRC preenchido = emite CT-e e MDF-e; vazio = emissor só de NFS-e
      const rntrcLimpo = String(rntrc || '').trim()
      const emiteCte = Boolean(rntrcLimpo)

      if (!cnpj || cnpj.length !== 14) throw new Error('CNPJ Incorreto')
      if (!razao_social) throw new Error('Razão Social Incorreto')
      const telefoneNumbers = telefone.replace(/\D/g, '')
      if (!telefoneNumbers) throw new Error('Telefone Inválido')
      if (!emiteCte && !ambiente_nfse)
        throw new Error('Informe o RNTRC (CT-e e MDF-e) ou o Ambiente da NFS-e')
      if (emiteCte && rntrcLimpo.length !== 8) throw new Error('RNTRC Incorreto')
      if (emiteCte && !inscricao_estadual) throw new Error('Inscrição Estadual Incorreto')
      if (!uf) throw new Error('Estado Inválido')
      if (!indicador_icms) throw new Error('Indicador ICMS Inválido')
      if (!validade_certificado) throw new Error('Data de Expiração do Certificado Inválida')
      if (emiteCte && !cte_num_serie) throw new Error('Cte Número de Série e Obrigatório')
      if (emiteCte && !id && !cte_ultimo_emitido) throw new Error('Cte: Número do Último Emitido')
      if (!token_homolog) throw new Error('Token Homologação é obrigatório')
      if (!token_prod) throw new Error('Token Produção é obrigatório')
      if (ambiente_nfse) {
        if (!city_id) throw new Error('Informe a Cidade do emissor: é o município emissor da NFS-e')
        if (ambiente_nfse === 'municipal' && !String(inscricao_municipal || '').trim())
          throw new Error(
            'Informe a Inscrição Municipal: obrigatória no ambiente municipal da NFS-e',
          )
        if (!opcao_simples_nacional) throw new Error('Selecione a Opção pelo Simples Nacional')
        if (opcao_simples_nacional === OPCAO_SIMPLES_ME_EPP && !regime_apuracao_simples)
          throw new Error('Selecione o Regime de Apuração do Simples Nacional')
        if (regime_especial_tributacao === null || regime_especial_tributacao === undefined)
          throw new Error('Selecione o Regime Especial de Tributação')
      }

      const emissor = await EmissoresHttp.saveEmissor({
        id,
        rntrc: rntrcLimpo,
        cnpj,
        razao_social,
        inscricao_estadual,
        uf,
        indicador_icms,
        telefone: telefoneNumbers,
        activated,
        validade_certificado,
        token_homolog,
        token_prod,
        cte_num_serie: cte_num_serie || null,
        cte_ultimo_emitido: id ? undefined : cte_ultimo_emitido,
        address,
        number,
        district,
        city_id,
        cep,
        ambiente_nfse,
        inscricao_municipal,
        opcao_simples_nacional: ambiente_nfse ? opcao_simples_nacional : null,
        regime_apuracao_simples:
          ambiente_nfse && opcao_simples_nacional === OPCAO_SIMPLES_ME_EPP
            ? regime_apuracao_simples
            : null,
        regime_especial_tributacao: ambiente_nfse ? regime_especial_tributacao : null,
        email,
      })

      onSuccess(emissor)
    } catch (error) {
      onError(errorHandler(error))
    }
  }

  const fetchUFs = async (uf_selected = null) => {
    await SystemHttp.getUfs()
      .then(ufs => {
        if (uf_selected)
          setState(prevState => ({
            ...prevState,
            ufs: ufs,
            selectedUf: ufs.find(uf => uf.uf === uf_selected),
          }))
        else setState(prevState => ({ ...prevState, ufs: ufs }))
      })
      .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
  }

  const fetchCities = async uf_id => {
    await SystemHttp.getCities(uf_id)
      .then(cities => {
        if (state.city_id) {
          setState(prevState => ({
            ...prevState,
            cities: cities,
            selectedCity: cities.find(city => city.id === Number(state.city_id)),
          }))
        } else {
          setState(prevState => ({
            ...prevState,
            cities: cities,
          }))
        }
      })
      .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
  }
  const onCnpjChange = cnpj => {
    setState({
      ...state,
      cnpj,
    })
    if (cnpj.length === 14) fetchCnpjData(cnpj)
  }
  const fetchCnpjData = async cnpj => {
    if (!cnpj || cnpj.length !== 14) return

    try {
      const data = await SystemHttp.getCnpjDataFocusNfe(cnpj)

      // Atualizar os campos do emissor
      setState(prevState => ({
        ...prevState,
        razao_social: data.razao_social,
        address: data.endereco.logradouro,
        number: data.endereco.numero,
        district: data.endereco.bairro,
        cep: data.endereco.cep,
        uf: data.endereco.uf,
        city_id: data.endereco.codigo_ibge, // Usar codigo_ibge como no cadastro de empresa
      }))

      // Buscar e definir UFs
      const ufs = await SystemHttp.getUfs()
      const ufEncontrada = ufs.find(uf => uf.uf === data.endereco.uf)

      if (ufEncontrada) {
        setState(prevState => ({
          ...prevState,
          ufs: ufs,
          selectedUf: ufEncontrada,
        }))
      }
    } catch (error) {
      onError('Não foi possível buscar os dados do CNPJ automaticamente')
    }
  }

  const onUltEmitidoSalvo = emissorAtualizado => {
    setState(prevState => ({
      ...prevState,
      cte_ultimo_emitido: emissorAtualizado.cte_ultimo_emitido,
    }))
    setShowUltEmitidoModal(false)
    onEmissorUpdated(emissorAtualizado)
  }

  // Render
  return (
    <>
      <form className="p-grid">
        <div className="p-md-4 p-col-12">
          <InputCnpj
            label="CNPJ :*"
            marginTop={10}
            value={state.cnpj}
            onChange={({ value }) => onCnpjChange(value)}
          />
        </div>
        <div className="p-md-8 p-col-12">
          <InputText
            label="Razão Social :*"
            marginTop={10}
            value={state.razao_social}
            onChange={value => setState({ ...state, razao_social: value })}
          />
        </div>
        <div className="p-md-4 p-col-12">
          <InputPhone
            label="Telefone :*"
            marginTop={10}
            value={state.telefone}
            onChange={value => setState({ ...state, telefone: value })}
          />
        </div>
        <div className="p-md-4 p-col-12">
          <InputNumeroInteiro
            label={state.ambiente_nfse ? 'RNTRC :' : 'RNTRC :*'}
            marginTop={10}
            value={state.rntrc}
            onChange={value => setState({ ...state, rntrc: value })}
            format={'########'}
            id="rntrc"
          />
          <p style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
            Registro Nacional de Transportadores Rodoviários de Cargas
            {state.ambiente_nfse ? ' (só para CT-e e MDF-e)' : ''}
          </p>
        </div>
        <div className="p-md-4 p-col-12">
          <InputNumeroInteiro
            label={state.ambiente_nfse ? 'Inscrição Estadual :' : 'Inscrição Estadual :*'}
            marginTop={10}
            value={state.inscricao_estadual}
            onChange={value => setState({ ...state, inscricao_estadual: value })}
            format={'##############'}
          />
        </div>
        <div className="p-md-4 p-col-12">
          <CustomDropdown
            optionLabel="name"
            options={state.ufs}
            value={state.selectedUf}
            label="Estado :*"
            filter={true}
            onChange={value => {
              setState(prevState => {
                prevState.selectedUf = value
                prevState.uf = value.uf
                prevState.cities = [] // Limpar cidades ao mudar estado
                prevState.selectedCity = null
                prevState.city_id = null
                return { ...prevState }
              })
              if (value && value.id) {
                fetchCities(value.id)
              }
            }}
          />
        </div>
        <div className="p-md-4 p-col-12">
          <CustomDropdown
            optionLabel="name"
            options={IndicadorIcmsOptions}
            value={state.selectedIndicadorICMS}
            label="Indicador ICMS :*"
            onChange={value => {
              setState(prevState => {
                prevState.selectedIndicadorICMS = value
                prevState.indicador_icms = value.id
                return { ...prevState }
              })
            }}
          />
        </div>
        <div className="p-col-4" style={{ display: 'flex', alignItems: 'end' }}>
          <CustomCalendar
            label="Data Expiração Certificado:"
            value={state.validade_certificado}
            onChange={value => {
              setState({ ...state, validade_certificado: value })
            }}
          />
        </div>
        <div className="p-col-6">
          <InputNumeroInteiro
            label={state.ambiente_nfse ? 'Cte Núm. Série :' : 'Cte Núm. Série :*'}
            marginTop={10}
            value={state.cte_num_serie}
            onChange={value => setState({ ...state, cte_num_serie: value })}
          />
        </div>
        <div className="p-col-6">
          {state.id ? (
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 5 }}>
              <div style={{ flex: 1 }}>
                <InputNumeroInteiro
                  label="Cte Últ. Emitido:"
                  marginTop={10}
                  value={state.cte_ultimo_emitido}
                  disabled
                />
              </div>
              <Btn
                onClick={() => setShowUltEmitidoModal(true)}
                style={{ minWidth: 'auto', height: 30, padding: '0 10px' }}
              >
                <i className="pi pi-pencil" />
              </Btn>
            </div>
          ) : (
            <InputNumeroInteiro
              label={state.ambiente_nfse ? 'Cte Últ. Emitido:' : 'Cte Últ. Emitido:*'}
              marginTop={10}
              value={state.cte_ultimo_emitido}
              onChange={value => setState({ ...state, cte_ultimo_emitido: value })}
            />
          )}
        </div>
        <div className="p-col-4" style={{ display: 'flex', alignItems: 'end' }}>
          <CustomCheckbox
            onChange={value => setState({ ...state, activated: value })}
            checked={state.activated}
          >
            Ativo
          </CustomCheckbox>
        </div>

        <div className="p-col-12" style={{ marginTop: 10 }}>
          <Fieldset legend="Autenticação" toggleable={false}>
            <div className="p-grid">
              <div className="p-md-6 p-col-12">
                <InputText
                  label="Token Homologação :*"
                  marginTop={10}
                  value={state.token_homolog}
                  onChange={value => setState({ ...state, token_homolog: value })}
                />
              </div>
              <div className="p-md-6 p-col-12">
                <InputText
                  label="Token Produção :*"
                  marginTop={10}
                  value={state.token_prod}
                  onChange={value => setState({ ...state, token_prod: value })}
                />
              </div>
            </div>
          </Fieldset>
        </div>

        <div className="p-col-12" style={{ marginTop: 10 }}>
          <Fieldset legend="NFS-e" toggleable={false}>
            <div className="p-grid">
              <div className="p-md-6 p-col-12">
                <CustomDropdown
                  optionLabel="label"
                  options={AMBIENTES_NFSE}
                  value={AMBIENTES_NFSE.find(item => item.value === (state.ambiente_nfse || null))}
                  label="Ambiente da NFS-e :"
                  onChange={item => setState({ ...state, ambiente_nfse: item.value })}
                />
                <p style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                  Deve refletir o ambiente habilitado no painel da Focus
                </p>
              </div>
              {state.ambiente_nfse && (
                <>
                  <div className="p-md-6 p-col-12">
                    <InputText
                      label={
                        state.ambiente_nfse === 'municipal'
                          ? 'Inscrição Municipal :*'
                          : 'Inscrição Municipal :'
                      }
                      marginTop={10}
                      value={state.inscricao_municipal}
                      maxLength={15}
                      onChange={value => setState({ ...state, inscricao_municipal: value })}
                    />
                  </div>
                  <div className="p-md-6 p-col-12">
                    <CustomDropdown
                      optionLabel="label"
                      options={OPCOES_SIMPLES_NACIONAL}
                      value={
                        OPCOES_SIMPLES_NACIONAL.find(
                          item => item.value === state.opcao_simples_nacional,
                        ) || null
                      }
                      label="Opção pelo Simples Nacional :*"
                      onChange={item =>
                        setState({
                          ...state,
                          opcao_simples_nacional: item.value,
                          regime_apuracao_simples:
                            item.value === OPCAO_SIMPLES_ME_EPP
                              ? state.regime_apuracao_simples
                              : null,
                        })
                      }
                    />
                  </div>
                  {state.opcao_simples_nacional === OPCAO_SIMPLES_ME_EPP && (
                    <div className="p-md-6 p-col-12">
                      <CustomDropdown
                        optionLabel="label"
                        options={REGIMES_APURACAO_SIMPLES}
                        value={
                          REGIMES_APURACAO_SIMPLES.find(
                            item => item.value === state.regime_apuracao_simples,
                          ) || null
                        }
                        label="Regime de Apuração do Simples :*"
                        onChange={item =>
                          setState({ ...state, regime_apuracao_simples: item.value })
                        }
                      />
                    </div>
                  )}
                  <div className="p-md-6 p-col-12">
                    <CustomDropdown
                      optionLabel="label"
                      options={REGIMES_ESPECIAIS_TRIBUTACAO}
                      value={
                        REGIMES_ESPECIAIS_TRIBUTACAO.find(
                          item => item.value === state.regime_especial_tributacao,
                        ) || null
                      }
                      label="Regime Especial de Tributação :*"
                      onChange={item =>
                        setState({ ...state, regime_especial_tributacao: item.value })
                      }
                    />
                  </div>
                  <div className="p-md-6 p-col-12">
                    <InputText
                      label="E-mail :"
                      marginTop={10}
                      value={state.email}
                      maxLength={80}
                      onChange={value => setState({ ...state, email: value })}
                    />
                  </div>
                </>
              )}
            </div>
          </Fieldset>
        </div>

        <div className="p-col-12" style={{ marginTop: 20, marginBottom: 10 }}>
          <h4>Dados de Endereço (CTe Globalizado e município emissor da NFS-e)</h4>
        </div>

        <div className="p-md-8 p-col-12">
          <InputText
            label="Endereço :"
            marginTop={10}
            value={state.address}
            onChange={value => setState({ ...state, address: value })}
          />
        </div>
        <div className="p-md-4 p-col-12">
          <InputText
            label="Número :"
            marginTop={10}
            value={state.number}
            onChange={value => setState({ ...state, number: value })}
          />
        </div>
        <div className="p-md-6 p-col-12">
          <InputText
            label="Bairro :"
            marginTop={10}
            value={state.district}
            onChange={value => setState({ ...state, district: value })}
          />
        </div>
        <div className="p-md-6 p-col-12">
          <InputText
            label="CEP :"
            marginTop={10}
            value={state.cep}
            onChange={value => setState({ ...state, cep: value })}
          />
        </div>
        <div className="p-md-6 p-col-12">
          <CustomDropdown
            optionLabel="name"
            options={state.cities}
            value={state.selectedCity}
            label={state.ambiente_nfse ? 'Cidade :*' : 'Cidade :'}
            filter={true}
            onChange={value => {
              setState(prevState => {
                prevState.selectedCity = value
                prevState.city_id = value ? value.id : null
                return { ...prevState }
              })
            }}
          />
        </div>

        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
      <ModalUltimoEmitido
        isVisible={showUltEmitidoModal}
        emissor={state}
        onClose={() => setShowUltEmitidoModal(false)}
        onSuccess={onUltEmitidoSalvo}
        onError={onError}
      />
    </>
  )
}

function EmissorDataTable({ emissores, onRowClick }) {
  const [globalFilter, setGlobalFilter] = useState('')

  return (
    <DataTable
      value={emissores}
      selectionMode="single"
      onSelectionChange={e => onRowClick(e.value)}
      paginator
      rows={10}
      globalFilter={globalFilter}
      header={<CustomDataTableHeader onChange={setGlobalFilter} />}
    >
      <Column field="id" header="Código" style={tableCellCentered(80)} />
      <Column field="razao_social" header="Emissor" />
      <Column
        field="cnpj"
        header="CNPJ"
        style={{ textAlign: 'center', width: 200 }}
        body={rowData => <Cnpj>{rowData.cnpj}</Cnpj>}
      />
      <Column field="rntrc" header="RNTRC" style={tableCellCentered(200)} />
      <Column
        field="inscricao_estadual"
        header="Inscrição Estadual"
        style={tableCellCentered(200)}
      />
      <Column
        field="validade_certificado"
        header="Validade Certificado"
        style={tableCellCentered(200)}
        body={item => <DateTime>{item.validade_certificado}</DateTime>}
      />
      <Column
        field="ambiente_nfse"
        header="NFS-e"
        style={tableCellCentered(120)}
        body={item =>
          item.ambiente_nfse === 'municipal'
            ? 'Municipal'
            : item.ambiente_nfse === 'nacional'
              ? 'Nacional'
              : '—'
        }
      />
      <Column
        field="activated"
        header="Ativo"
        style={{ textAlign: 'center', width: 100 }}
        body={rowData => <CustomCheckbox disabled checked={rowData.activated} />}
      />
    </DataTable>
  )
}

export default connect()(withRouter(EmissorCte))
